export default "__VITE_ASSET__FG2YpqIq__"